import Button from 'react-bootstrap/Button'
import { Alert } from 'react-bootstrap'
import * as H from 'history'
import  React from 'react'
import { DocumentController } from '../../../controllers/DocumentController'
import { ClaimDocument } from '../../../models/ClaimDocument'
import { ClaimModel } from '../../../models/ClaimModel'
import { IField } from '../../../shared/fields'
import { TableBody, TableColumn, TableHeader } from '../../../shared/table'
import {
  DocumentTypeInfo, isApplicationForm1DocumentPendingScoring, isApplicationForm1DocumentValid, isApplicationForm1DocumentInfected,
} from './DocumentTypeInfo'

export interface DocumentSectionProps {
    history: H.History
    model: ClaimModel
    info: DocumentTypeInfo
    item: string
    onChange: { (changes: Partial<ClaimModel>): any }
}

export interface DocumentSectionState {
    errorMessage?: string
}

export class ApplicationForm1DocumentSection extends React.Component<DocumentSectionProps, DocumentSectionState> implements IField {
    ajax: DocumentController
    container: HTMLDivElement

    constructor(props: DocumentSectionProps) {
      super(props)
      this.ajax = new DocumentController()

      this.state = {
        errorMessage: null,
      }
    }

    removeFile(id: string) {
      if (confirm('Are you sure you want to delete the uploaded file?')) {
        this.ajax.deleteDocument(null, this.props.model.claimId, id, () => {
          const newList = this.props.model.documents.filter((d) => d.id != id)
          this.props.onChange({ documents: newList })
        })
      }
    }

    downloadFile(id: string) {
      window.open(`/api/document/download?claimId=${this.props.model.claimId}&documentId=${id}`, '_blank')
    }

    getErrorMessage(): string {
      if (this.props.info.required(this.props.model, this.props.item) === true) {
        if (this.getItems().length == 0) {
          return 'Required'
        }
      }
      return null
    }

    getItems = () => this.props.model.documents.filter((d) => d.code == this.props.info.code && d.itemId == this.props.item)

    validate(callback: { (res: boolean): any }, focus?: boolean) {
      const errorMessage = this.getErrorMessage()
      this.setError(errorMessage, () => {
        if (errorMessage) {
          if (focus === true) {
            this.focus()
          }
        }
        callback && callback(!errorMessage)
      })
    }

    setError(errorMessage?: string, callback?: { (): any }) {
      this.setState({ errorMessage }, callback)
    }

    focus() {
      const temp = this.container.getElementsByTagName('button')
      if (temp && temp.length > 0) {
        temp[0].focus()
      }
    }

    getStatus(r: ClaimDocument): JSX.Element | string {
      if (isApplicationForm1DocumentValid(r) || !this.props.model.machineLearningWithScore) { return <div className="fas fa-check" /> }

      if (isApplicationForm1DocumentPendingScoring(r)) { return <div className="fas fa-spinner fa-spin" /> }

      if (isApplicationForm1DocumentInfected(r)) {
        return (
          <Alert className='emdg-page-alerts emdg-page-alerts--error'>
            This file has been marked as infected by antivirus software and cannot be scored. Please remove and upload a valid file.
          </Alert>
        )
      }

      return 'Applicant to confirm'
    }

    render() {
      const items = this.getItems()

      const acceptMultiple = this.props.info.multipleFiles(this.props.model, this.props.item)

      const columns: TableColumn<ClaimDocument>[] = [
        { name: 'File name', content: (r) => <a href="#" onClick={(e) => { e.preventDefault(); this.downloadFile(r.id) }}>{r.name}</a> },
        { name: 'Status', content: (r) => this.getStatus(r) },
        { name: '', content: (r) => <a className="float-right" href="#" onClick={(e) => { e.preventDefault(); this.removeFile(r.id) }}>Remove</a> },
      ]

      return (
        <div
          ref={(r) => this.container = r}
          className={'table-container'
            + `${this.state.errorMessage ? ' table-container-invalid' : ''}`}
        >
          <TableHeader label={this.props.info.title(this.props.model, this.props.item)}>
            <Button
              id={`btnAdd${(this.props.info.title(this.props.model, this.props.item) || '').replace(/ /g, '_')}`}
              className="prepare-btn"
              onClick={(e) => this.props.history.push(`/claim/${this.props.model.claimId}/prepare/documents/${this.props.info.code}/${this.props.item}`)}
            >
              {(acceptMultiple || items.length == 0) ? 'Add' : 'Replace'}
            </Button>
          </TableHeader>
          <div style={{ display: items.length > 0 ? '' : 'none' }}>
            <TableBody<ClaimDocument>
              id="documents"
              columns={columns}
              value={items}
              noRowsMessage="No document(s) uploaded"
              alwaysShowAllRows
            />
          </div>
        </div>
      )
    }
}
